export const isDevEnv = () => process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
export const dispatchOnDev = (callback: () => void) => isDevEnv() && callback();
